<template>
    <div class="field-checkbox field-checkbox_with-bg">
      <input class="field-checkbox__input"
             type="checkbox"
             id="agreement"
             value="value"
             v-model="checked"
      >
      <label class="field-checkbox__label" for="agreement">
        <a :href="link" target="_blank" rel="noopener">
          Я даю согласие на&nbsp;обработку своих персональных данных
        </a>
      </label>
    </div>
</template>
<script>
  export default {
    name: 'CheckboxAgreement',
    props: {
      link: {
        type: String,
        default: 'https://storage.yandexcloud.net/boxberrysite-public/Doc_C2C/4_Согласие на обработку персональных данных.pdf',
      },
    },
    data() {
      return {
        checked: false,
      }
    },
    updated() {
      this.$emit('updateChecked', this.checked);
    },
  }
</script>
